import styled, { css } from 'styled-components';
import { TitleXSmall500, BodySmall500 } from '@nebula/global-styles';

const getBackgroundColor = (state, theme) => {
  switch (state) {
    case 'error':
      return theme.color.messaging.red[10];
    case 'disabled':
      return theme.color.ui.grey[10];
    default:
      return theme.color.brand.white;
  }
};

const getBorderColor = (state, theme) => {
  switch (state) {
    case 'error':
      return theme.color.messaging.red[60];
    case 'disabled':
      return theme.color.ui.grey[20];
    default:
      return theme.color.ui.grey[70];
  }
};

const recurlyElementStyles = css`
  .recurly-element {
    width: 100%;
    height: 2.375rem;
    margin: 0;
    padding: 0;
    border: 0;
    outline: 0;
    background-color: ${({ $state, theme }) => getBackgroundColor($state, theme)};
    color: ${({ theme }) => theme.color.ui.grey[70]};
    font-size: 1rem;
    font-weight: 400;
  }
`;

const baseInputStyles = css`
  display: grid;
  align-items: center;
  width: 100%;
  padding: 0.25rem 0.75rem;
  background-color: ${({ $state, theme }) => getBackgroundColor($state, theme)};
  border-width: 1px;
  border-radius: ${({ theme }) => theme.borderRadius.xsSmall.rem};
  border-style: solid;
  border-color: ${({ theme, $state }) => getBorderColor($state, theme)};
  box-shadow: none;
  box-shadow: ${({ $focused, theme }) => $focused && `${theme.focus.shadow}`};
  outline: ${({ $state, theme }) => $state === 'error' && `solid 1px ${theme.color.messaging.red[60]}`};
  transition: ${({ theme }) => theme.focus.transition};
  cursor: ${({ $state }) => ($state === 'disabled' ? 'not-allowed' : 'unset')};

  &:hover {
    ${({ $state, theme }) => $state !== 'error' && $state !== 'disabled' && `border-color: ${theme.color.ui.grey[90]}`};
  }
`;

export const Form = styled.form`
  margin: 1rem 0 0;
  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    max-width: ${({ differentWidthForChangePaymentMethod }) =>
      differentWidthForChangePaymentMethod ? '24.3011rem' : '19.4375rem'};
  }
`;

export const Label = styled(TitleXSmall500)`
  margin: 1rem 0 0.25rem;
`;

export const CardSummary = styled.div`
  display: flex;
  margin: 0 0 0.25rem;

  ${Label} {
    flex: 1;
    margin: 0;
  }
`;

export const CardNumberInput = styled.div`
  ${baseInputStyles}
  ${recurlyElementStyles}
  grid-auto-flow: column;
  grid-auto-columns: auto 1fr auto;
  grid-gap: 0.5rem;
`;

export const NameInput = styled.div`
  ${baseInputStyles}
  ${recurlyElementStyles}
  grid-auto-flow: column;
  grid-auto-columns: 1fr auto;
  grid-gap: 0.5rem;
`;

export const ExpiryDate = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-gap: 1rem;
`;

export const DateInput = styled.div`
  ${baseInputStyles}
  ${recurlyElementStyles}
  position: relative;

  > svg {
    position: absolute;
    right: 0.75rem;
  }
`;

export const SecurityCode = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-gap: 1rem;
  grid-template-columns: 7.5rem minmax(auto, 10.9375rem);
  align-items: center;
  margin: 0 0 0.75rem;
`;

export const SecurityInput = styled.div`
  ${baseInputStyles}
  ${recurlyElementStyles}
  grid-auto-flow: column;
  grid-gap: 1rem;
`;

export const SecurityIcon = styled(BodySmall500)`
  display: grid;
  grid-auto-flow: column;
  grid-gap: 0.75rem;
  margin: 0;
  padding: 0.5rem 0.75rem;
  background-color: ${({ theme }) => theme.color.decorative.sapphire[10]};
  border-radius: 0.5rem;
`;

export const IconsContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  gap: 0.5rem;
  align-items: center;
`;
